module.exports = __webpack_public_path__ + "assets/img/zizaran.3527c51b.png";